import { UserInterface } from "@/types/UserInterface";

export function getFirstLastName(user: UserInterface) {
  return user
    ? `${user.firstName ? user.firstName : ""} ${
        user.lastName ? user.lastName : ""
      }`
    : "";
}
export function getFullName(user: UserInterface) {
  return user ? `${user.firstName} ${user.middleName} ${user.lastName}` : "";
}
